import { Card, CardContent } from "@babackapp/ui/components/card";
import PremiumFeatureBadge from "@babackapp/ui/components/premium-feature-badge";
import { cn } from "@babackapp/ui/lib/utils";
import { useIsRetractionOnly } from "@/hooks/use-is-retraction-only";
import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense";
import { LogisticianOptionsForm } from "./logistician-options-form";
import ShopSettingsWorkflowForm from "./shop-settings-workflow-form";
import { LockClosedIcon } from "@heroicons/react/24/solid";

export default function WorkflowLogisiticianCard() {
  const { data: shop } = useCurrentShopSuspense();

  const disabled = false && !shop.plan.workflowLogistician;
  const isRetractionOnly = useIsRetractionOnly();

  if (isRetractionOnly) {
    return (
      <div className="relative overflow-hidden rounded-lg border min-h-[160px]">
        {/* Mock statique */}
        <div className="pointer-events-none select-none p-6 space-y-4">
          {/* Switch Workflow logisticien */}
          <div className="flex items-center justify-between">
            <div className="space-y-0.5">
              <div className="text-sm font-medium">Workflow logisticien</div>
              <div className="text-xs text-muted-foreground">
                Activez vos workflows logisticiens pour une gestion optimale des
                retours
              </div>
            </div>
            <div className="h-5 w-9 rounded-full bg-indigo-500 border" />
          </div>
          {/* Switch Traitements automatiques */}
          <div className="flex items-center justify-between">
            <div className="space-y-0.5">
              <div className="text-sm font-medium">
                Traitements automatiques
              </div>
              <div className="text-xs text-muted-foreground">
                Traiter automatiquement les articles après validation du
                logisticien
              </div>
            </div>
            <div className="h-5 w-9 rounded-full bg-indigo-500 border" />
          </div>
          {/* Règles d'exception fictives */}
          <div className="space-y-2">
            <div className="text-xs font-medium text-muted-foreground uppercase tracking-wide">
              Règles d&apos;exception
            </div>
            {[
              { n: 1, name: "Ne pas traiter les Bundle" },
              { n: 2, name: "Ne pas traiter les MKP" },
              { n: 3, name: "Exception" },
            ].map((rule) => (
              <div
                key={rule.n}
                className="flex items-center gap-3 rounded-md border bg-background px-3 py-2 text-xs"
              >
                <span className="font-semibold text-muted-foreground w-4 text-right">
                  {rule.n}
                </span>
                <span className="font-medium flex-1">{rule.name}</span>
                <div className="h-4 w-8 rounded-full bg-muted border" />
              </div>
            ))}
          </div>
        </div>

        {/* Overlay sans CTA */}
        <div className="absolute inset-0 flex flex-col items-center justify-center gap-2 bg-background/70 backdrop-blur-[1.2px] px-6 text-center">
          <div className="flex h-9 w-9 items-center justify-center rounded-full bg-muted">
            <LockClosedIcon className="h-4 w-4 text-muted-foreground" />
          </div>
          <p className="text-sm font-semibold text-foreground">
            Workflow logisticien
          </p>
          <p className="text-xs text-muted-foreground max-w-sm">
            Gérez le traitement des articles par vos logisticiens, avec des
            règles d&apos;exception personnalisables. Disponible dans le plan
            Lite.
          </p>
        </div>
      </div>
    );
  }

  return (
    <Card className="w-full">
      <CardContent className="mt-4 flex-col flex gap-4 px-4">
        <div
          className={cn(
            "rounded-md flex justify-between flex-1 p-4",
            disabled && "bg-[#ffa73209]",
          )}
        >
          <div className="flex flex-col flex-1 gap-8">
            <ShopSettingsWorkflowForm />
            <LogisticianOptionsForm />
          </div>

          {disabled && <PremiumFeatureBadge />}
        </div>
      </CardContent>
    </Card>
  );
}
